var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFalling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    id: "Falling--Streamline-Sharp-Material",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Falling Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#bfbfbf",
    d: "m13.2999 22.45 -1.5 -0.3 0.775 -4.2 -3.65 -2.75 -1.375 -6 -2.625 2.25 0.775 3.7 -1.5 0.3 -0.925 -4.5 4.35 -3.875c0.35 -0.31665 0.75835 -0.44165 1.225 -0.375 0.46665 0.06665 0.925 0.19165 1.375 0.375 0.56665 0.23335 1.15 0.40415 1.75 0.5125 0.6 0.10835 1.2 0.12085 1.8 0.0375 0.55 -0.08335 1.0625 -0.27085 1.5375 -0.5625 0.475 -0.29165 0.92915 -0.6125 1.3625 -0.9625l0.95 1.175c-0.45 0.35 -0.91665 0.68335 -1.4 1 -0.48335 0.31665 -1 0.55 -1.55 0.7 -0.58335 0.16665 -1.18335 0.23335 -1.8 0.2 -0.61665 -0.03335 -1.21665 -0.125 -1.8 -0.275l0.825 3.75 3.85 -0.725 4.9 3.475 -0.9 1.2 -4.2 -2.925 -4.25 0.85 3.025 2.225 -1.025 5.7Zm-5.3 -17.45c-0.48335 0 -0.89585 -0.170835 -1.2375 -0.5125s-0.5125 -0.754165 -0.5125 -1.2375c0 -0.483335 0.17085 -0.895835 0.5125 -1.2375C7.10405 1.670835 7.51655 1.5 7.9999 1.5c0.48335 0 0.89585 0.170835 1.2375 0.5125s0.5125 0.754165 0.5125 1.2375c0 0.483335 -0.17085 0.895835 -0.5125 1.2375 -0.34165 0.341665 -0.75415 0.5125 -1.2375 0.5125Z",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFalling);
export default __webpack_public_path__ + "static/media/Falling.15bc68355ae2083d7bf12bb5c51ce893.svg";
export { ForwardRef as ReactComponent };